import {ApiClient} from "../generated/ApiClient";
import {Aborted, useFetcher} from "./useFetcher";



export const useLastSongsKey = () => ({
    queryKey: ["useLastSongsKey"],
    queryFn: useFetcher(() => new ApiClient().getApiSearchLastSongs({}, {
        credentials: "include",
        signal: Aborted().signal
    })),
    refetchInterval: 15000,
    refetchOnMount: false
})
